import React, {useState} from "react";
import {connect} from "react-redux";
import {updateDataStore} from "../../../actions/foundationActions";
import {makeAppTopMod} from "src/utilities/utilityFunctions";
import BlogInsert from "../../../utilities/BlogInsert";
import {Scrollbars} from "react-custom-scrollbars";

const FAQcordion = (props) => {

    const tabHolderStyle = {
        width:"110%",
        height:562,
        paddingTop:4,
        display:"flex",
        color:"#e4ce91",
        fontFamily:"Comic Sans MS",
        fontSize:"16pt"
    };

    let [answer,setAnswer] = useState("");

    let questions = document.getElementsByClassName("an-faq");
    let questionArray = props.dataStore.faqs ? props.dataStore.faqs : [];

    const makeActive = (activeQuestion,index)=> {
        setAnswer(activeQuestion);
        for (let i = 0; i < questionArray.length; i++) {
            questions[i].classList.remove("an-active-faq");
            questions[i].classList.add("faq-inactv");
        }
        document.getElementById("faq" + index).classList.remove("faq-inactv");
        document.getElementById("faq" + index).classList.add("an-active-faq");
    };

  const questionDisplay = (Array.isArray((questionArray))
      ? (questionArray?.map((qstn, index) => (
            <li key={index}><span id={"faq"+index} key={"faq"+index} onClick={()=>makeActive(qstn,index)} className="an-faq faq-inactv mb-0 pb-2 px-2">{qstn.title}</span></li>
        )))
      : null
  );

    let answerDisplay = answer ? <BlogInsert content={answer} bgcolor={"transparent"}/> : "";
    return (
        <div style={tabHolderStyle} id="faqCordion">
            <ul className="box-inner-tn" style={{width:615,height:300}}>
                {questionDisplay}
                <li><span id={"faqlast"} key={"faqlast"} onClick={()=>makeAppTopMod('components/TDP/content/FAQs')} className="an-faq faq-inactv mb-0 pb-2 px-2">More FAQs</span></li>
            </ul>
            <div style={{width:465,height:300,marginLeft:"auto"}}>
                <Scrollbars style={{height:"100%"}}>
                {answerDisplay}
                </Scrollbars>
           </div>
        </div>
    )
};

const mapStateToProps = (state) =>{
    return {
        appSettings:state.appSettings,
        dataStore:state.dataStore,
        user:state.user
    };
};

export default connect(mapStateToProps,{
    updateDataStore
})(FAQcordion);
